<form #form="ngForm">
  <div class="relative">
    <!-- Required field sign -->
    <div class="warning-img contact-position" style="left: -25px;"
      *ngIf="((!dollarInput.valid && !dollarInput.untouched) || formSubmitted) && (dollarInput.errors?.required)">
      <img src="assets/images/wake-up-icon.svg" alt="">
    </div>

    <!-- Dollar sign -->
    <span *ngIf="isDollarInput" class="dollar-input-icon">$</span>

    <!-- Input -->
    <input type="text" [placeholder]="placeholder" (focus)="onFocus($event)" (focusout)="onFocusOut()"
      class="form-control rounded-0 {{classes}}" [readonly]="readonly"
      [ngClass]="{'dollar-input': isDollarInput,
                  'warning-border' : ((!dollarInput.valid && !dollarInput.untouched) || formSubmitted) && (dollarInput.errors?.required)}"
      [name]="name" [(ngModel)]="displayValue" [required]="required"
      #dollarInput="ngModel" [disabled]="disabled" (paste)="onPaste($event)"
      (blur)="onBlur()"/>

    <!-- Required Field -->
    <div class="validation-message"
      *ngIf="((!dollarInput.valid && !dollarInput.untouched) || formSubmitted) && (dollarInput.errors?.required)">
      Field is required
    </div>
  </div>
</form>
